import React from "react";

interface ImageProps {
  src: string;
  alt: string;
  width: number;
  height: number;
  loading?: "lazy" | "eager";
  decoding?: "async" | "sync" | "auto";
  className?: string;
}

/**
 * Required-alt, required-dimensions image. Lazy-loaded by default.
 * Use everywhere instead of bare <img> tags.
 */
export function Image({
  src,
  alt,
  width,
  height,
  loading = "lazy",
  decoding = "async",
  className = "",
}: ImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      decoding={decoding}
      className={className}
    />
  );
}

export default Image;
